<template>
    <Header class="main-header">
        <template slot="head">
            <slot name="head"></slot>
        </template>
        <template slot="center">
            <a-menu :defaultSelectedKeys="[ nowtab ]" mode="horizontal" :selectable="false" class="main-tab">
                <a-menu-item v-for="tab of tabs" :key="tab.key">
                    <a :href="tab.link">{{ tab.name }}</a>
                </a-menu-item>
            </a-menu>
        </template>
        <!-- <template slot="tail">
            <div class="to-old">
                <a-button type="primary" shape="round" size="small" @click="toOld">回到旧版</a-button>
            </div>
        </template> -->
    </Header>
</template>

<script>
import { MAIN_PAGES } from '../constant';
import Header from "./Header.vue";

export default {
    props: {
        nowtab: String
    },
    data: () => ({
        tabs: MAIN_PAGES
    }),
    methods: {
        toOld() {
            localStorage.setItem('prefer', 'new');
        }
    },
    components: {
        Header
    }
}
</script>

<style lang="less" scoped>
.main-header {
    background: #FFFFFF;
    height: 52px;
    line-height: 52px;
}
.main-tab {
    margin: -1px auto 1px;
    border-bottom: none;
}
.to-old {
    display: flex;
    align-items: center;
    margin-left: 8px;
}
</style>

<style scoped>
.main-header >>> .site-brand .logo {
    color: black;
}
</style>